export enum CityEnum {
  MARRAKECH = 1,
  CASABLANCA = 2,
  TANGER = 3,
  AGADIR = 4,
  RABAT = 5
}

export const CityNames: { [key in CityEnum]: string } = {
  [CityEnum.MARRAKECH]: 'Marrakech',
  [CityEnum.CASABLANCA]: 'Casablanca',
  [CityEnum.TANGER]: 'Tanger',
  [CityEnum.AGADIR]: 'Agadir',
  [CityEnum.RABAT]: 'Rabat'
};